import { NeedsHistoryEntryDto } from '@act/shared/data-transfer-objects';
import { userAppSelectors } from 'redux/slices/usersSlice';
import { visitsAppSelectors } from 'redux/slices/visitsSlice';
import { CollapsibleHistoryCard } from './CollapsibleHistoryCard';
import { getHistoryEntryDateLine } from './history-card-helpers';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface NeedVisitHistoryEntryProps {
  historyEntry: NeedsHistoryEntryDto;
}

export const NeedVisitHistoryEntry = ({
  historyEntry,
}: NeedVisitHistoryEntryProps) => {
  const visit = visitsAppSelectors.useSelectVisitById(historyEntry.visitId);
  const creator = userAppSelectors.useSelectUserById(visit?.createdBy);
  const creatorName = creator?.name;

  return (
    <CollapsibleHistoryCard
      title={`Resource Visited: ${historyEntry.resource.title}`}
      subtitle={getHistoryEntryDateLine(historyEntry?.createdAt, creatorName)}
      icon={<VisibilityIcon />}
    />
  );
};
